import React from "react";
import { View, Text, Image, StyleSheet, Pressable } from "react-native";

function RecommendedCourseCard({ title, category, price, description, imageUrl, tag, onEnrollPress }) {
  return (
    <View style={styles.card}>
      <View style={styles.imageWrapper}>
        <Image source={{ uri: imageUrl }} style={styles.image} />
        <View style={styles.tag}>
          <Text style={styles.tagText}>{tag}</Text>
        </View>
      </View>
      <View style={styles.content}>
        <Text style={styles.title}>{title}</Text>
        <Text style={styles.category}>🎓 {category}</Text>
        <Text style={styles.price}>${price}</Text>
        <Text style={styles.description} numberOfLines={2}>
          {description}
        </Text>
        <Pressable onPress={onEnrollPress} style={styles.button}>
          <Text style={styles.buttonText}>Enroll</Text>
        </Pressable>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    width: 400,
    alignSelf: "center",
    backgroundColor: "#fff",
    borderRadius: 16,
    overflow: "hidden",
    borderColor: "#EAECF0",
    borderWidth: 1,
  },
  imageWrapper: {
    position: "relative",
  },
  image: {
    width: "100%",
    height: 184,
    resizeMode: "cover",
  },
  tag: {
    position: "absolute",
    top: 12,
    left: 12,
    backgroundColor: "#EEF4FF",
    borderRadius: 999,
    paddingHorizontal: 10,
    paddingVertical: 4,
  },
  tagText: {
    color: "#3E68FE",
    fontSize: 12,
    fontWeight: "600",
  },
  content: {
    gap: 12,
    padding: 24,
  },
  title: {
    fontSize: 16,
    fontWeight: "700",
    color: "#101828",
  },
  category: {
    fontSize: 14,
    color: "#667085",
  },
  price: {
    fontSize: 16,
    fontWeight: "700",
    marginVertical: 4,
    color: "#101828",
  },
  description: {
    fontSize: 13,
    color: "#667085",
    flexShrink: 1,
    flexWrap: "wrap",
  },
  button: {
    backgroundColor: "#3E68FE",
    borderRadius: 8,
    paddingVertical: 10,
    paddingHorizontal: 16,
    marginTop: 12,
    alignSelf: "flex-start",
  },
  buttonText: {
    color: "#fff",
    fontWeight: "600",
  },
});

export default RecommendedCourseCard;
